const RANDOM_BYTES = 16;

// randomUUID needs a secure context; plain-http dev hosts fall back to getRandomValues.
export function newClientRequestId(): string {
    if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(RANDOM_BYTES));
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
